import { IJsonSerializable } from "../util/interfaces";
import { OpDBScriptTable } from "./op-db-script-table";
import { TypeHelper } from "../../helpers/type-helper";
import { OpDBScriptResult } from "./op-db-script-result";

export class OpDBScriptDataSet implements IJsonSerializable {
    // Members

    public tables: OpDBScriptTable[]

    // Members End

    // Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // Ctor End

    // IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || TypeHelper.isJSONCompressed(opObj)) {
                if (opObj.T != null) {
                    this.tables = opObj.T.map((data: any) => new OpDBScriptTable(data))
                }
            } else {
                if (opObj.Tables != null) {
                    this.tables = opObj.Tables.map((data: any) => new OpDBScriptTable(data))
                }
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            const result: any = {
                T: this.tables.map((table: OpDBScriptTable) => table.toJSON(compressed))
            }

            TypeHelper.setJSONCompressedFlag(result)
            TypeHelper.deleteNulls(result)

            return result
        }
            return {
                Tables: this.tables.map((table: OpDBScriptTable) => table.toJSON(compressed))
            }
        }
        // IJsonSerializable Implementation End
    }
